import { Grid, SxProps, Theme, GridProps, GridSize, Breakpoint } from '@mui/material';
import { ErrorAlert } from '../ErrorAlert/ErrorAlert';
import { FetchErrorsType } from '@/types/types/general/errors';
import { RefObject } from 'react';

type GridSizeProps = {
    [key in Breakpoint]?: GridSize;
};

type ExtendedGridProps = GridProps & GridSizeProps;

interface FormGridErrorsProps {
    errors: {
        generalServerError?: string | FetchErrorsType;
        unassignedPropertyErrors?: string[];
    };
    gridSx?: SxProps<Theme>;
    gridClassName?: string;
    generalErrorId?: string;
    generalErrorRef?: RefObject<HTMLDivElement | null>;
    generalErrorTestId?: string;
    gridProps?: Partial<ExtendedGridProps>;
}

export const FormGridErrors = ({
    errors,
    gridSx,
    gridClassName,
    generalErrorId = 'general_error_message_box',
    generalErrorRef,
    generalErrorTestId,
    gridProps = { xs: 12 },
}: FormGridErrorsProps) => {
    const { xs, sm, md, lg, xl, ...props } = gridProps;
    const gridSize = { xs, sm, md, lg, xl };
    return (
        <>
            {errors.generalServerError && (
                <Grid
                    size={gridSize}
                    {...props}
                    tabIndex={0}
                    sx={{ ...gridSx }}
                    className={gridClassName}
                    ref={generalErrorRef}
                    data-testid={generalErrorTestId}
                >
                    <ErrorAlert id={generalErrorId} errorMessage={errors.generalServerError} />
                </Grid>
            )}
            {errors.unassignedPropertyErrors &&
                errors.unassignedPropertyErrors.map((errorMessage, index) => (
                    <Grid
                        key={`unknown_property_error_${index}`}
                        size={gridSize}
                        {...props}
                        tabIndex={0}
                        sx={{ ...gridSx }}
                        className={gridClassName}
                    >
                        <ErrorAlert
                            id={`unknown_property_error_message_box_${index}`}
                            errorMessage={errorMessage}
                        />
                    </Grid>
                ))}
        </>
    );
};
